/**
 * Format a billing renewal date from Firestore Timestamp, ISO string, or Date.
 * @param {import('firebase/firestore').Timestamp | Date | string | number | { seconds?: number } | null | undefined} value
 * @returns {string}
 */
export function formatBillingRenewalDate(value) {
  if (!value) return 'N/A';

  let dateObj;
  if (typeof value.toDate === 'function') {
    dateObj = value.toDate();
  } else if (
    typeof value === 'object' &&
    value !== null &&
    typeof value.seconds === 'number'
  ) {
    dateObj = new Date(value.seconds * 1000);
  } else {
    dateObj = new Date(value);
  }

  if (Number.isNaN(dateObj.getTime())) return 'N/A';

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(dateObj);
}
